export enum ROUTES {
	NOT_FOUND = '*',
	DEFAULT = '/',
	LOGIN = '/login',
	MANAGER = '/manager',
	EMPLOYEE = `/employee`,
	DASHBOARD = `/manager/dashboard`,
	HYPERSCHEDULER = `/manager/hyperscheduler`,
	BROADCAST = '/manager/broadcast',
	ADD_BROADCAST = '/manager/broadcast/add-broadcast',
	EDIT_BROADCAST = '/manager/broadcast/edit-broadcast/:id',
	VIEW_BROADCAST = '/manager/broadcast/view-broadcast/:id',
	SCHEDULE = '/manager/schedule',
	SITUATION_ROOM = '/manager/situation-room',
	TO_DO = '/manager/todo',
	GAMEMASTER='/manager/gamemaster',
	ONBOARDING='/manager/onboarding',
	EVENTS='/manager/events',
	CREATE_EVENT='/manager/events/create',
	EVENT_DETAILS='/manager/events/details',
	CREATE_CUSTOMER='/manager/customers/create',
	EDIT_CUSTOMER='/manager/customers/edit/:id',
	LOGBOOK='/manager/logbook',
	CHECKLIST='/manager/checklist',
	SCORECARD='/manager/scorecard',
	TO_DO_ID = '/manager/todo/get/:id',
	ADD_TO_DO = '/manager/todo/add-todo',
	EDIT_TO_DO = '/manager/todo/edit/:id',
	LABORSABER = '/manager/laborsaber',
	GUESTPROTECT = '/guest-protect/:id',
	GUESTCONNECT = '/manager/guest-connect',
	GUESTCONNECTSENTIMENT = '/manager/guest-connect/sentiment',
	GUESTCONNECTSTAFF = '/guest-connect/check/:id',
	SETTINGS = '/manager/settings',
	ADD_SHIFT_NOTES = '/manager/logbook/add-shift-note',
	EDIT_SHIFT_NOTES = '/manager/logbook/edit-shift-note/:noteId',
	VIEW_SHIFT_NOTES = '/manager/logbook/view-shift-note/:noteId',
	ADD_EMPLOYEE_NOTES = '/manager/logbook/add-employee-note',
	EDIT_EMPLOYEE_NOTES = '/manager/logbook/edit-employee-note/:noteId',
	VIEW_EMPLOYEE_NOTES = '/manager/logbook/view-employee-note/:noteId',
	ADD_SALES_TRAFFIC_NOTES = '/manager/logbook/add-sales-traffic',
}
